import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import styles from "./Plans.module.scss";
import Image from "next/image";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function RewardsTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label='basic tabs example'
          sx={{ width: '100%' }}
        >
          <Tab
            sx={{ textTransform: 'capitalize', width: '110px' }}
            label='Phase 1'
            {...a11yProps(0)}
          />
          <Tab
            sx={{ textTransform: 'capitalize', width: '110px' }}
            label='Phase 2'
            {...a11yProps(1)}
          />
          <Tab
            sx={{ textTransform: 'capitalize', width: '110px' }}
            label='Phase 3'
            {...a11yProps(2)}
          />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0} sx={{ padding: 0 }}>
        <div className={styles.box}>
          <div className={styles.content}>
            <h3 className={styles.titelPrice}>Internal price</h3>
            <h4 className={styles.price}>$0.0125</h4>

            <div className={styles.Percentage}>
              <h3 className={styles.titlePer}>Supply Percentage</h3>
              <h4 className={styles.pricePercentage}>50%</h4>

              <h3 className={styles.titlePer}>Supply Percentage</h3>
              <h4 className={styles.pricePercentage}>2,592,000,000 tokens</h4>
            </div>
            <div className='flex items-end justify-end'>
              <Image
                alt='coins'
                src='/assets/Image/coins1.png'
                width={80}
                height={44}
                className={styles.image}
              />
            </div>
          </div>
        </div>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <div className={styles.box}>
          <div className={styles.content}>
            <h3 className={styles.titelPrice}>Internal price</h3>
            <h4 className={styles.price}>$0.03</h4>

            <div className={styles.Percentage}>
              <h3 className={styles.titlePer}>Supply Percentage</h3>
              <h4 className={styles.pricePercentage}>30 %</h4>

              <h3 className={styles.titlePer}>Supply Percentage</h3>
              <h4 className={styles.pricePercentage}>1,555,200,000 tokens</h4>
            </div>
            <div className='flex items-end justify-end'>
              <Image
                alt='coins2'
                src='/assets/Image/coin2.png'
                width={80}
                height={44}
                className={styles.image}
              />
            </div>
          </div>
        </div>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <div className={styles.box}>
          <div className={styles.content}>
            <h3 className={styles.titelPrice}>Internal price</h3>
            <h4 className={styles.price}>$0.06</h4>

            <div className={styles.Percentage}>
              <h3 className={styles.titlePer}>Supply Percentage</h3>
              <h4 className={styles.pricePercentage}>20 %</h4>

              <h3 className={styles.titlePer}>Supply Percentage</h3>
              <h4 className={styles.pricePercentage}>1,036,800,000 tokens</h4>
            </div>
            <div className='flex items-end justify-end'>
              <Image
                alt='coins3'
                src='/assets/Image/coin3.png'
                width={80}
                height={44}
                className={styles.image}
              />
            </div>
          </div>
        </div>
      </TabPanel>
    </Box>
  )
}
